import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { FieldRenderProps as WrappedFieldProps } from 'react-final-form';
import { get } from 'lodash';

import { ReduxStore } from '@trip-ux/redux-store';
import { DatePickerProps } from '@trip-ux/components';

import { GenericDatePicker } from './components';
import { QuickQuoteFormProps } from '../booking/quote/QuickQuoteTypes';
import { SUPPORTED_LOCALES } from '@trip-ux/constants';

export const LocaleDatePicker: FC<WrappedFieldProps<string> & QuickQuoteFormProps & DatePickerProps> = ({
  ...props
}) => {
  const { locale } = useSelector((store: ReduxStore) => ({
    locale: get(store, 'config.locale')
  }));

  return <GenericDatePicker {...props} language={locale as SUPPORTED_LOCALES} />;
};

LocaleDatePicker.displayName = 'LocaleDatePicker';
export default LocaleDatePicker;
